import React from 'react'

function TenderTextKLE() {
  return (
    <embed src="\pdfs\EA2.2.1-2_kl-e_em_08.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextKLE